import React from "react";
import { NavLink } from "react-router-dom";
import { WordRestrictions } from "../../../../models/extension/WordExtention";
import CourseNoteCourseView from "../../../../models/views/education/CourseNoteCourseView";
import CourseNoteService from "../../../../services/education/CourseNoteService";
import NotFoundDataInDate from "../../../shared/not-found-data-in-date/NotFoundDataInDate";
import { resolveCourseMediaUrl } from "../course-note.data";
import "../CourseNote.scss";
import CourseNoteListState, {
  CourseNoteListProps,
} from "./CourseNoteList.models";
import "./CourseNoteList.scss";

export default class CourseNoteList extends React.PureComponent<
  CourseNoteListProps,
  CourseNoteListState
> {
  courseNoteService: CourseNoteService;

  constructor(props: CourseNoteListProps) {
    super(props);
    this.courseNoteService = new CourseNoteService();
    this.state = {
      courseNotes: [],
      searchText: "",
    };
  }

  componentDidMount() {
    this.getCourses();
  }

  componentDidUpdate(prevProps: CourseNoteListProps) {
    if (
      prevProps.courseId !== this.props.courseId ||
      prevProps.categoryId !== this.props.categoryId
    ) {
      this.getCourses();
    }
  }

  getCourses = () => {
    const self = this;
    const { courseId, categoryId } = this.props;
    if (courseId == null || categoryId == null) return;

    this.courseNoteService
      .getCourses(courseId, categoryId)
      .then(function (response) {
        self.setState({ courseNotes: response ?? [] });
      });
  };

  handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchText: e.target.value });
  };

  getFilteredNotes = (): CourseNoteCourseView[] => {
    const { courseNotes, searchText } = this.state;
    const query = searchText.trim();
    if (!query) return courseNotes;
    return courseNotes.filter((item) => item.title.includes(query));
  };

  render(): React.ReactNode {
    const { searchText } = this.state;
    const filteredNotes = this.getFilteredNotes();

    return (
      <div
        className="dropdown-list course-note-area course-note-list-area"
        style={{ height: "90vh" }}
      >
        <div className="search-row">
          <div className="search-box">
            <span className="mdi mdi-magnify"></span>
            <input
              type="text"
              value={searchText}
              onChange={this.handleSearch}
              placeholder="جستجو..."
            />
          </div>
        </div>

        {filteredNotes.length > 0 ? (
          this.notesView(filteredNotes)
        ) : (
          <NotFoundDataInDate title="موردی یافت نشد" />
        )}
      </div>
    );
  }

  notesView(notes: CourseNoteCourseView[]) {
    const { courseId, categoryId } = this.props;

    return (
      <>
        {notes.map((note) => (
          <NavLink
            key={note.id}
            to={`/CourseNoteSessions?courseNoteId=${note.id}&courseId=${courseId}&categoryId=${categoryId}`}
            className="col-12 notspace margin-top note-link"
          >
            <div className="tk-inline card-boundel">
              <div
                className="col-2 notspace"
                style={{ display: "flex", alignItems: "center" }}
              >
                <img
                  className="icon"
                  src={resolveCourseMediaUrl(note.fileAttachmentId)}
                  width="56"
                  height="56"
                  alt="course note icon"
                />
              </div>
              <div
                className="col-8 notspace"
                style={{ textAlign: "right", marginRight: "16px" }}
              >
                <div className="pd-detail">
                  <div className="course-title">
                    <div className="tk-tooltip">
                      {WordRestrictions(note.title, 28)}
                    </div>
                  </div>
                  <div className="course-subtitle">
                    <label>
                      {WordRestrictions(
                        `${note.courseNoteCategoryTitle ?? ""} - ${note.courseBaseTitle ?? ""}`,
                        32,
                      )}
                    </label>
                  </div>
                  <div className="note-meta">
                    <span className="stars">
                      <label className="mdi mdi-star"></label>
                      <label className="mdi mdi-star"></label>
                      <label className="mdi mdi-star"></label>
                      <label className="mdi mdi-star"></label>
                      <label className="mdi mdi-star"></label>
                    </span>
                    <span className="session-count">
                      <label className="mdi mdi-play-circle-outline"></label>
                      <label>{note.sessionCount} جلسه</label>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-2 notspace note-arrow">
                <label className="mdi mdi-chevron-left"></label>
              </div>
            </div>
          </NavLink>
        ))}
      </>
    );
  }
}
